<ng-container *transloco="let t; read: 'project-icon'">
  <div class="project-icon__heading">
    <h4>{{ t('header') }}</h4>

    <p>{{ t('content') }}</p>
  </div>

  <div class="project-icon__icon-section-container">
    <div class="project-icon_icon-wrapper">
      @if (projectIcon) {
        <img [src]="projectIcon" />
      }
      @if (!projectIcon) {
        <div>{{ t('select-icon') }}</div>
      }

      <div
        [ngStyle]="{ visibility: !isReadOnly ? 'visible' : 'hidden' }"
        class="project-icon__icon-overlay"
        (click)="selectIconDialog()"
      >
        <div class="project-icon__overlay-message">{{ t('edit') }}</div>
      </div>
    </div>

    <div
      [ngClass]="
        !isReadOnly && projectIcon
          ? 'project-icon__button--visible'
          : 'project-icon__button--hidden'
      "
    >
      <xi-default-button
        color="CX"
        fill="link"
        [text]="t('remove')"
        [hasAnimation]="false"
        (onClick)="onRemoveProjectIcon()"
      ></xi-default-button>
    </div>
  </div>
</ng-container>
